import Vue from 'vue'
import Router from 'vue-router'

import Login from './login/login';

import warp from './warp/warp';

Vue.use(Router);

let router = new Router({
    mode:"history",
    routes: [
        ...Login,
        ...warp,
        {
            path: '/',
            name: 'HomePage',
            redirect: to => {
                const  { hash ,params ,query } = to;
                let token = JSON.parse(localStorage.getItem("login")) || '';
                let _token = "";
                if(token.data && token.data.token){
                    _token = token.data.token
                }
                if(_token){
                    return { path: '/warp/companymanagement/organizationmanagement'}
                }else{
                    return {path:'/login'}
                }
            },
            meta:{
                layout:false
            }
        }
    ]
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js